import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../helpers/request.helpers";
import { SessionUser } from "../store/auth";

export type SessionResponse = {
  Token: string;
  User: SessionUser;
};

export function useSession() {
  return useQuery<SessionResponse, Error>({
    queryKey: ["get-session-user"],
    queryFn: async () => await apiGet("/get-session-user"),
    retry: false,
    staleTime: 10000,
  });
}
